import { defineMessages as o } from "react-intl";
var e = o({
  loadingResultsErrorAction: {
    id: "comboboxWithApiPagination.errorAction",
    defaultMessage: "Reload"
  },
  loadingResultsErrorMessage: {
    id: "comboboxWithApiPagination.errorMessage",
    defaultMessage: "Failed to load options"
  },
  loadingResultsErrorIconLabel: {
    id: "comboboxWithApiPagination.errorIconLabel",
    defaultMessage: "Error"
  },
  loadingAriaLabel: {
    id: "comboboxWithApiPagination.loadingAriaLabel",
    defaultMessage: "Loading..."
  },
  loadingMoreAriaLabel: {
    id: "comboboxWithApiPagination.loadingMoreAriaLabel",
    defaultMessage: "Loading more..."
  },
  noResults: {
    id: "comboboxWithApiPagination.noResults",
    defaultMessage: "No results found"
  },
  clearButtonAriaLabel: {
    id: "comboboxWithApiPagination.clearButtonAriaLabel",
    defaultMessage: "Clear input and selection"
  }
});
export { e as default };